import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ViewMoreAddressPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-view-more-address',
  templateUrl: 'view-more-address.html',
})
export class ViewMoreAddressPage {

  public user_data: any;
  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.user_data = this.navParams.get("user_data");
    console.log('user_data', this.user_data);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ViewMoreAddressPage');
  }
  public closeModal(){
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/view-more-address/view-more-address.ts